import "cookie-consent-js/src/cookie-consent.css";

export function requestCookieConsent(window) {
  window.addEventListener("load", function () {
    window.cookieconsent.initialise({
      revokeBtn: "<div class='cc-revoke'></div>",
      type: "opt-in",
      theme: "classic",
      palette: {
        popup: {
          background: "#d9edf7",
          text: "#679",
        },
        button: {
          background: "#5de",
          text: "#fff",
        },
      },
      content: {
        link: "About consent form",
        href: "https://2gdpr.com/cookies",
      },
      onInitialise: function (status) {
        if (status === cookieconsent.status.allow) enableGa();
      },
      /* eslint-disable */
      onStatusChange: function (status) {
        if (this.hasConsented()) enableGa();
      },
    });
  });

  function enableGa() {
    // Paste here your scripts that use cookies requiring consent. See examples below
    window.enableGa = true;
  }
}
